// CardIconList.js
import React from "react";
import { HiOutlineLightBulb } from "react-icons/hi";
import { MdPower } from "react-icons/md";
import { BsHouseDoor } from "react-icons/bs";
import { GiWorld } from "react-icons/gi";
import { PRIMARY } from "../../assets/colors";
import useWindowDimensions from "../../hooks/useWindowDimensions";

const styles = {
  display: "flex",
  placeContent: "space-between",
  alignItems: "center",
};
const iconStyles = {
  width: "2.5em",
  height: "2.5em",
};

const Data = [
  {
    text: "Loyer mensuel garanti sans impayés ni vacance.",
    component: <HiOutlineLightBulb color={PRIMARY} style={{ ...iconStyles }} />,
  },
  {
    text: "Zéro gestion : nous gérons locataires, entretien et administratif.",
    component: <MdPower color={PRIMARY} style={{ ...iconStyles }} />,
  },
  {
    text: "Locataires professionnels triés sur le volet pour votre bien.",
    component: <BsHouseDoor color={PRIMARY} style={{ ...iconStyles }} />,
  },
  {
    text: "Votre logement est protégé et entretenu en continu.",
    component: <GiWorld color={PRIMARY} style={{ ...iconStyles }} />,
  },
];

const CardIconList = () => {
  const { width } = useWindowDimensions();

  return (
    <>
      {width <= 992 ? (
        <div>
          {Data.map((item, i) => (
            <div key={i} style={{ ...styles, marginBottom: "1rem" }}>
              <div
                style={{
                  width: "10%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {item.component}
              </div>
              <span style={{ width: "90%", paddingLeft: 10 }}>{item.text}</span>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default CardIconList;
